export var dropdownValues = {
    'stateList': [
        { 'value': '', 'text': 'Select a state' },
        { 'value': 'AL', 'text': 'Alabama' },
        { 'value': 'AK', 'text': 'Alaska' },
        { 'value': 'AZ', 'text': 'Arizona' },
        { 'value': 'AR', 'text': 'Arkansas' },
        { 'value': 'CA', 'text': 'California' },
        { 'value': 'CO', 'text': 'Colorado' },
        { 'value': 'CT', 'text': 'Connecticut' },
        { 'value': 'DE', 'text': 'Delaware' },
        { 'value': 'DC', 'text': 'District Of Columbia' },
        { 'value': 'FL', 'text': 'Florida' },
        { 'value': 'GA', 'text': 'Georgia' },
        { 'value': '', 'text': 'Hawaii - Not available' },
        { 'value': 'ID', 'text': 'Idaho' },
        { 'value': 'IL', 'text': 'Illinois' },
        { 'value': 'IN', 'text': 'Indiana' },
        { 'value': 'IA', 'text': 'Iowa' },
        { 'value': 'KS', 'text': 'Kansas' },
        { 'value': 'KY', 'text': 'Kentucky' },
        { 'value': 'LA', 'text': 'Louisiana' },
        { 'value': 'ME', 'text': 'Maine' },
        { 'value': 'MD', 'text': 'Maryland' },
        { 'value': 'MA', 'text': 'Massachusetts' },
        { 'value': 'MI', 'text': 'Michigan' },
        { 'value': 'MN', 'text': 'Minnesota' },
        { 'value': 'MS', 'text': 'Mississippi' },
        { 'value': 'MO', 'text': 'Missouri' },
        { 'value': 'MT', 'text': 'Montana' },
        { 'value': 'NE', 'text': 'Nebraska' },
        { 'value': 'NV', 'text': 'Nevada' },
        { 'value': 'NH', 'text': 'New Hampshire' },
        { 'value': 'NJ', 'text': 'New Jersey' },
        { 'value': 'NM', 'text': 'New Mexico' },
        { 'value': 'null', 'text': 'New York - Not available' },
        { 'value': 'NC', 'text': 'North Carolina' },
        { 'value': 'ND', 'text': 'North Dakota' },
        { 'value': 'OH', 'text': 'Ohio' },
        { 'value': 'OK', 'text': 'Oklahoma' },
        { 'value': 'OR', 'text': 'Oregon' },
        { 'value': 'PA', 'text': 'Pennsylvania' },
        { 'value': 'RI', 'text': 'Rhode Island' },
        { 'value': 'SC', 'text': 'South Carolina' },
        { 'value': 'SD', 'text': 'South Dakota' },
        { 'value': 'TN', 'text': 'Tennessee' },
        { 'value': 'TX', 'text': 'Texas' },
        { 'value': 'UT', 'text': 'Utah' },
        { 'value': 'VT', 'text': 'Vermont' },
        { 'value': 'VA', 'text': 'Virginia' },
        { 'value': 'WA', 'text': 'Washington' },
        { 'value': 'WV', 'text': 'West Virginia' },
        { 'value': 'WI', 'text': 'Wisconsin' },
        { 'value': 'WY', 'text': 'Wyoming' }
    ],
    'hauList': [
        { 'sc': '27512581', 'value': '27512581', 'text': 'BestMoney' },
        { 'sc': '27512583', 'value': '27512583', 'text': 'BestOnlineMortgageLoan' },
        { 'sc': '27512686', 'value': '27512686', 'text': 'Consumers Advocate' },
        { 'sc': '27512736', 'value': '27512736', 'text': 'Google Search' },
        { 'sc': '27512699', 'value': '27512699', 'text': 'LendingTree' },
        { 'sc': '27512556', 'value': '27512556', 'text': 'LoansMarket' },
        { 'sc': '27512717', 'value': '27512717', 'text': 'Online Ad' },
        { 'sc': '27512726', 'value': '27512726', 'text': 'Other' },
        { 'sc': '27512741', 'value': '27512741', 'text': 'Radio' },
        { 'sc': '27512745', 'value': 'Referrer', 'text': 'Referred by Someone' },
        { 'sc': '27512709', 'value': '27512709', 'text': 'Social Media' },
        { 'sc': '27512721', 'value': '27512721', 'text': 'TV' }
    ]
};
export var defaultDf = {
    flowId: 'purchase',
    steps: ['propertyTypeP', 'firstTimeBuyer', 'timeFrame'],
    currentStepIndex: 0,
    fieldsValue: {},
};
//Special Campaign Source Codes:
export var Campaign = {
    Nerd_Purch: 6340524,
    Nerd_Purch_All: [6340524, // default
        11105454, 11105472, 11105508, 11105533, // Excellent, Good, Fair, Poor 
        13372616, 13372586, 13372567, 13372551, // Excellent, Good, Fair, Poor + TimeFrame:GOOD2GO
        14468988, //Nerdwallet        :: Nerdwallet - Pur - Fair/GD/EX/620+ (GOOD2GO) - VA
        14468942, //Nerdwallet        :: Nerdwallet - Pur - Poor/619- (GOOD2GO) - VA
        14469096, //Nerdwallet        :: Nerdwallet - Pur - Fair/GD/EX/620+ - VA
        14469109, //Nerdwallet        :: Nerdwallet - Pur - Poor/619- - VA
        14469261, //Nerdwallet        :: Nerdwallet - Pur - Fair/GD/EX/620+ (GOOD2GO) - Jumbo
        14469247, //Nerdwallet        :: Nerdwallet - Pur - Poor/619- (GOOD2GO) - Jumbo
        14469278, //Nerdwallet        :: Nerdwallet - Pur - Fair/GD/EX/620+ - Jumbo
        14469290], //Nerdwallet        :: Nerdwallet - Pur - Poor/619- - Jumbo
    Adwords_Purch: 10498546,
    Adwords_Refi: 10498520,
    TV_Atlanta: 5661538,
    //         //Purch  //Refi
    Nerd_All: [7101456, 7101464, //Nerdwallet        :: Nerdwallet-Ratetable-Pur/Refi
        6340524, 6340509, //NerdWallet        :: Nerdwallet - Pur/Refi
        11105454, //NerdWallet        :: Nerdwallet - Pur - EX/720+-YYMM
        11105472, //NerdWallet        :: Nerdwallet - Pur - GD/680-719-YYMM
        11105508, //NerdWallet        :: Nerdwallet - Pur - Fair/620-679-YYMM
        11105533, //NerdWallet        :: Nerdwallet - Pur - Poor/619--YYMM
        13372616, //NerdWallet        :: Nerdwallet - Pur - EX/720+ (GOOD2GO)
        13372586, //NerdWallet        :: Nerdwallet - Pur - GD/680-719 (GOOD2GO)
        13372567, //NerdWallet        :: Nerdwallet - Pur - Fair/620-679 (GOOD2GO)
        13372551, //NerdWallet        :: Nerdwallet - Pur - Poor/619- (GOOD2GO)
        14468988, //Nerdwallet        :: Nerdwallet - Pur - Fair/GD/EX/620+ (GOOD2GO) - VA
        14468942, //Nerdwallet        :: Nerdwallet - Pur - Poor/619- (GOOD2GO) - VA
        14469096, //Nerdwallet        :: Nerdwallet - Pur - Fair/GD/EX/620+ - VA
        14469109, //Nerdwallet        :: Nerdwallet - Pur - Poor/619- - VA
        14469261, //Nerdwallet        :: Nerdwallet - Pur - Fair/GD/EX/620+ (GOOD2GO) - Jumbo
        14469247, //Nerdwallet        :: Nerdwallet - Pur - Poor/619- (GOOD2GO) - Jumbo
        14469278, //Nerdwallet        :: Nerdwallet - Pur - Fair/GD/EX/620+ - Jumbo
        14469290] //Nerdwallet        :: Nerdwallet - Pur - Poor/619- - Jumbo
    //,CA_ALL: [11207699, 11207716,    //ConsumersAdvocate :: Consumersadvocate.org_NonBrand_NA_Pros_US_Affiliate_2spot_Pur/Refi
    //           10949559, 10949579,  //ConsumersAdvocate :: Consumersadvocate.org_NonBrand_Refinance_NA_Pros_US_Affiliate_Pur/Refi
    //           10607314,10606642,   //ConsumersAdvocate :: Consumersadvocate.org_NonBrand_HELOC_NA_Pros_US_Affiliate_Pur/Refi
    //           9422065, 9422078]    //ConsumersAdvocate :: Consumersadvocate.org_NonBrand_NA_Pros_US_Affiliate_Pur/Refi
};
